import moment from 'moment';
import store from '@/store/store';
import getAdressFullString from '@/services/general/getAdressFullString';
import { dataDetailMapper as contactDetailMapper } from '@/mapping/contact.mapping';
import formatDateIso from '@/services/general/formatIsoDate';

export function dataListMapper(item) {
  return {
    ...item,
    num: item.id,
    libelleRecherche: item.nomCommercial || '',
    adressePostaleLibelle1: item.adressePostale ? item.adressePostale.adresse1 : '',
    ville: item.adressePostale ? item.adressePostale.ville : '',
    codePostal: item.adressePostale ? item.adressePostale.codePostal : '',
    latitude: item.adressePostale ? item.adressePostale.latitude : null,
    longitude: item.adressePostale ? item.adressePostale.longitude : null,
    adresse: getAdressFullString(item.adressePostale || { }),
  }
}

export function dataDetailMapper(client) {
  const clientResult = {
    ...client,
    num: client.id,
    nomCourt: client.libelle || '',
    numeroCompte: client.compteComptable || '',
    commentaire: client.commentairesInternes || '',
    fax: '',
    codeApe: client.ape || '',
    delaiPaiement: client.delaiReglement,
    numeroTva: client.tvaIntracommunautaire || '',
    adrIntitule1: client.adressePostale && client.adressePostale.intitule1 || '',
    adrIntitule2: client.adressePostale && client.adressePostale.intitule2 || '',
    adrIntitule3: client.adressePostale && client.adressePostale.intitule3 || '',
    adrLibelle1: client.adressePostale && client.adressePostale.adresse1 || '',
    adrLibelle2: client.adressePostale && client.adressePostale.adresse2 || '',
    adrLibelle3: client.adressePostale && client.adressePostale.adresse3 || '',
    adrVille: client.adressePostale && client.adressePostale.ville || '',
    adrPays: client.adressePostale && client.adressePostale.pays || '',
    adrCp: client.adressePostale && client.adressePostale.codePostal || '',
    adrFIntitule1: client.adresseFacturation && client.adresseFacturation.intitule1 ? client.adresseFacturation.intitule1 : '',
    adrFIntitule2: client.adresseFacturation && client.adresseFacturation.intitule2 ? client.adresseFacturation.intitule2 : '',
    adrFIntitule3: client.adresseFacturation && client.adresseFacturation.intitule3 ? client.adresseFacturation.intitule3 : '',
    adrFLibelle1: client.adresseFacturation && client.adresseFacturation.adresse1 ? client.adresseFacturation.adresse1 : '',
    adrFLibelle2: client.adresseFacturation && client.adresseFacturation.adresse2 ? client.adresseFacturation.adresse2 : '',
    adrFLibelle3: client.adresseFacturation && client.adresseFacturation.adresse3 ? client.adresseFacturation.adresse3 : '',
    adrFVille: client.adresseFacturation && client.adresseFacturation.ville ? client.adresseFacturation.ville : '',
    adrFCp: client.adresseFacturation && client.adresseFacturation.codePostal ? client.adresseFacturation.codePostal : '',
    contacts: client.contacts.map(contactDetailMapper),
    adrComplet: getAdressFullString(client.adressePostale || { }),
  };

  if (client.adressePostale && client.adressePostale.latitude) {
    const latitude = parseFloat(client.adressePostale.latitude);
    if (!isNaN(latitude)) clientResult.latitude = latitude;
  }
  
  if (client.adressePostale && client.adressePostale.longitude) {
    const longitude = parseFloat(client.adressePostale.longitude);
    if (!isNaN(longitude)) clientResult.longitude = longitude;
  }

  if (client.typologie !== 'Groupe') {
    clientResult.tiersParentId = client.tiersParentId || '';
    clientResult.tiersParent = client.tiersParent;
  } else {
    clientResult.tiersParentId = '';
    clientResult.tiersParent = null;
  }

  return clientResult;
}

export function dataPostCreateMapper(client) {
  const copieClient = { ...client };
  copieClient.prospect = typeof copieClient.prospect === 'boolean' ? copieClient.prospect : false;
  copieClient.lieuStockage = typeof copieClient.lieuStockage === 'boolean' ? copieClient.lieuStockage : false;
  return copieClient;
}

export function queryPanneauxSousContratMapper(query) {
  const societeActive = store.getters['societe/societeActive'];
  return {
    SkipCount: 0,
    MaxResultCount: 999999,
    Query: {
      ...query,
      societeId: societeActive.id,
      dateLigneAA: formatDateIso(moment()),
      typesDevisCommandeFacture : ['Commande'],
      sens: 'vente',
      etatsDevisCommandeFacture: ['Facture','Enregistre','FactureePartiellement'],
    },
    Sorting: 'creationTime DESC',
  };
}
